export default {
  path: 'u',
  indexRoute: { onEnter: (nextState, replace) => replace('/u/l') },
  getChildRoutes (location, callback) {
    require.ensure([], function (require) {
      callback(null, [
        require('./branches').default.login
      ])
    }, 'user-i')
  }
}



// WEBPACK FOOTER //
// ./src/routes/user-manage/index.js